import React, { useEffect, useState } from "react";
import {
  Box,
  Text,
  Flex,
  Checkbox,
  Icon,
  Heading,
  Button,
  Select,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Divider,
  Grid, // Import Grid component
} from "@chakra-ui/react";
import { InfoOutlineIcon } from "@chakra-ui/icons";
import { FaSync, FaPrint } from "react-icons/fa";
import axios from "axios";
import { BASE_URL } from "../../../Globalapi/Globalapi";

const Individual_Notice = () => {
  const [currentNotices, setCurrentNotices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const userId = sessionStorage.getItem("user_id");
  const userType = sessionStorage.getItem("user_type");

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(currentNotices.length / rowsPerPage);
  const indexOfLastNotice = currentPage * rowsPerPage;
  const indexOfFirstNotice = indexOfLastNotice - rowsPerPage;

  const [selectedNotice, setSelectedNotice] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  useEffect(() => {
    const fetchCurrentNotices = async () => {
      setLoading(true);
      setError(null);

      try {
        let url;
        if (userType === "3") {
          url = `${BASE_URL}/student/list_notice_board.php`;
        } else if (userType === "4") {
          url = `${BASE_URL}/guardian/list_notice_board.php`;
        } else if (userType === "2") {
          url =
            `${BASE_URL}/staff/profile/list_notice_board.php`;
        }

        const response = await axios.post(url, { pass: userId });

        if (response.data.success) {
          setCurrentNotices(response.data.data);
        } else {
          setCurrentNotices([]); // Set empty notices when API does not return success

          // setError(response.data.message);
        }
      } catch (error) {
        setCurrentNotices([]); // Set empty notices when API does not return success
      } finally {
        setLoading(false);
      }
    };

    fetchCurrentNotices();
  }, [userId, userType]);

  const handleNoticeClick = (notice) => {
    setSelectedNotice(notice);
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setSelectedNotice(null);
  };

  if (loading) return <Text>Loading...</Text>;
  if (error) return <Text color="red.500">{error}</Text>;

  return (
    <div style={{ backgroundColor: "#FBFBFD", height: "100vh" }}>
      <div className="teacher-list-container">
        <div className="header">
          <h1 style={{ fontSize: "20px", margin: 0 }}>Notice Board</h1>
          <div className="action-buttons">
            {/* <Button onClick={() => window.location.reload()} boxShadow="md" backgroundColor="white" fontSize="11px">
              <FaSync color="#515B73" />
            </Button> */}
            {/* <Button backgroundColor="white" fontSize="11px" boxShadow="md">
              <FaPrint color="#515B73" />
              Print PDF
            </Button> */}
          </div>
        </div>
        <div className="breadcrumb">
          <span>Admin</span> / <span>Announcement</span> / <span>Notice</span>
        </div>
      </div>

      <Box className="notice-list" style={{ minHeight: "100px" }} p={6} pb={1}>
        <Flex align="center" className="sb" p={3} >
          <Text mr={1}>Rows Per Page</Text>
          <Select
            width="100px"
            value={rowsPerPage}
            onChange={(e) => setRowsPerPage(Number(e.target.value))}
            borderColor="#E9EDF4"
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
          </Select>
          {/* <Text ml={2}>Entries</Text> */}
        </Flex>
        {currentNotices.length === 0 ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="200px" // Adjust height as needed
            borderRadius="md" // Optional: add rounded corners
          >
            <Text>No notices available</Text>
          </Box>
        ) : (
          <Grid
            templateColumns={{
              base: "repeat(1, 1fr)",
              sm: "repeat(2, 1fr)",
              md: "repeat(4, 1fr)",
            }} // 1-column on mobile, 2-column on small screens, 4-column on larger screens
            gap={4}
          >
            {" "}
            {/* 4-column grid */}
            {currentNotices
              .slice(indexOfFirstNotice, indexOfLastNotice)
              .map((notice) => (
                <Box
                  key={notice.id}
                  p={2}
                  mt={1}
                  mb={1}
                  shadow="md"
                  borderWidth="1px"
                  borderRadius="lg"
                  fontSize="xs"
                  backgroundColor="white"
                >
                  <Flex justify="space-between" align="center" mb={1}>
                    <Flex align="center">
                      <Checkbox mr={4} />
                      <Icon as={InfoOutlineIcon} boxSize={3} mr={4} />
                      <Box>
                        <Heading
                          fontSize="sm"
                          ml={0}
                          style={{ cursor: "pointer" }}
                          onClick={() => handleNoticeClick(notice)}
                        >
                          {notice.title}
                        </Heading>
                        {notice.created_at && (
                          <Text fontSize="xs" color="gray.500" mt={1}>
                            Created on: {notice.created_at}
                          </Text>
                        )}
                      </Box>
                    </Flex>
                  </Flex>
                </Box>
              ))}
          </Grid>
        )}
        <Flex justify="end" align="center" className="sb2"  p={3}>
          <Button
            onClick={() => handlePageChange(currentPage - 1)}
            isDisabled={currentPage === 1}
          >
            Prev
          </Button>

          <Flex mx={2}>
            {Array.from({ length: totalPages }, (_, i) => (
              <Button
                key={i}
                onClick={() => handlePageChange(i + 1)}
                colorScheme={currentPage === i + 1 ? "teal" : "gray"}
              >
                {i + 1}
              </Button>
            ))}
          </Flex>

          <Button
            onClick={() => handlePageChange(currentPage + 1)}
            isDisabled={currentPage === totalPages}
          >
            Next
          </Button>
        </Flex>
      </Box>

      {/* Modal for Notice Details */}
      <Modal isOpen={isModalOpen} onClose={handleModalClose} size="lg">
        <ModalOverlay />
        <ModalContent maxW="750px">
          <ModalHeader>Notice Details</ModalHeader>
          <Divider />
          <ModalCloseButton />
          <ModalBody>
            {selectedNotice && (
              <>
                <Text fontWeight="bold">{selectedNotice.title}</Text>
                <Text mt={2}>{selectedNotice.message}</Text>
                <Box mt={4}>
                  <Flex justify="space-between" alignItems="flex-start" mb={2}>
                    {selectedNotice.notice_date && (
                      <Box>
                        <Text fontSize="sm" fontWeight="bold" color="black">
                          Notice Date
                        </Text>
                        <Text fontSize="sm" color="gray.500">
                          {new Date(
                            selectedNotice.notice_date
                          ).toLocaleDateString()}
                        </Text>
                      </Box>
                    )}
                    {selectedNotice.publish_on && (
                      <Flex justify="flex-end" alignItems="flex-start" mb={2}>
                        <Box>
                          <Text fontSize="sm" fontWeight="bold" color="black">
                            Publish On
                          </Text>
                          <Text fontSize="sm" color="gray.500">
                            {new Date(
                              selectedNotice.publish_on
                            ).toLocaleDateString()}
                          </Text>
                        </Box>
                      </Flex>
                    )}
                  </Flex>
                </Box>
              </>
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              colorScheme="teal"
              variant="ghost"
              onClick={handleModalClose}
            >
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default Individual_Notice;
